import { render, staticRenderFns } from "./CoreTextarea.vue?vue&type=template&id=42e45e06&scoped=true&"
import script from "./CoreTextarea.vue?vue&type=script&lang=js&"
export * from "./CoreTextarea.vue?vue&type=script&lang=js&"
import style0 from "./CoreTextarea.vue?vue&type=style&index=0&id=42e45e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e45e06",
  null
  
)

export default component.exports